export const environment = {
  production: true,
  published: false,
  disableSw: false,
  backendUrl: 'https://geoxp-qal.aubertduval.com',
  baseUrl: '/',
  appName: 'GeoXP',
  envName: 'QUAL',
  version: '0.0.1',
  auth: {
    tenantId: 'ea0cabda-5ab6-4c4b-8bc3-1fa237655f08',
    clientId: 'b8f0600c-573e-46e2-85f6-074474baf8c0',
  },
  appInsightsKey: '94d0bf26-8184-4635-969c-4652608e4fe8',
  map: {
    center: [1.600870, 43.118585],
    zoom: 19,
    minZoom: 18
  },
}
